import { checkForScenario } from "./checkForScenario.js";


function init() {
    checkForScenario()
}

export {
    init   
}